import { combineReducers, Reducer } from "redux";
import FacebookBudgetConstants from "../constants/budgets/FacebookBudgetConstants";

const entitiesReducer: Reducer<any> = (state = {}, action) => {
    switch (action.type) {
        case FacebookBudgetConstants.REQUEST_FACEBOOK_BUDGETS:
        case FacebookBudgetConstants.REQUEST_FACEBOOK_BUDGETS_FAIL:
        case FacebookBudgetConstants.REQUEST_CLIENT_FACEBOOK_BUDGETS:
        case FacebookBudgetConstants.REQUEST_CLIENT_FACEBOOK_BUDGETS_FAIL:
            return {};
        case FacebookBudgetConstants.REQUEST_FACEBOOK_BUDGETS_SUCCESS:
        case FacebookBudgetConstants.REQUEST_CLIENT_FACEBOOK_BUDGETS_SUCCESS:
            return { ...action.payload.budgets };
        default:
            return state;
    }
};

const loading: Reducer<boolean> = (state = false, action) => {
    switch (action.type) {
        case FacebookBudgetConstants.REQUEST_FACEBOOK_BUDGETS:
        case FacebookBudgetConstants.REQUEST_CLIENT_FACEBOOK_BUDGETS:
            return true;
        case FacebookBudgetConstants.REQUEST_FACEBOOK_BUDGETS_SUCCESS:
        case FacebookBudgetConstants.REQUEST_FACEBOOK_BUDGETS_FAIL:
        case FacebookBudgetConstants.REQUEST_CLIENT_FACEBOOK_BUDGETS_SUCCESS:
        case FacebookBudgetConstants.REQUEST_CLIENT_FACEBOOK_BUDGETS_FAIL:
            return false;
        default:
            return state;
    }
};

const loadingMessage: Reducer<string> = (state = "", action) => {
    switch (action.type) {
        case FacebookBudgetConstants.REQUEST_FACEBOOK_BUDGETS_SPINNER:
            return action.payload.loadingMessage;
        default:
            return state;
    }
};

export default combineReducers({
    entities: entitiesReducer,
    loading,
    loadingMessage
});
